const LABELS: Record<string, string> = {
  email: 'Email',
  telegram_username: 'Telegram',
  telegram_id: 'Telegram ID',
  whatsapp_number: 'WhatsApp',
  phone: 'Телефон',
  user_id: 'ID пользователя',
  device_id: 'Device ID',
  widget_user_id: 'ID пользователя',
  custom: 'Пользовательский',
}

export function identifierTypeLabel(type: string | null | undefined): string {
  if (!type) return '—'
  const k = type.toString().trim().toLowerCase()
  return LABELS[k] || type
}

/** Keep bearer resume keys out of editable customer profile fields. */
export function visibleCustomerIdentifiers<T extends { identifier_type: string; identifier_value: string }>(rows: T[]): T[] {
  const devices = new Set(rows.filter(r => r.identifier_type.toLowerCase() === 'device_id').map(r => r.identifier_value))
  return rows.filter(r => r.identifier_type.toLowerCase() !== 'user_id' || (!r.identifier_value.startsWith('widget-device:') && !devices.has(r.identifier_value)))
}
